var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45312 1.5C2.03891 1.5 1.70312 1.83579 1.70312 2.25V15.75C1.70312 16.1642 2.03891 16.5 2.45312 16.5H12.9531C13.3673 16.5 13.7031 16.1642 13.7031 15.75V5.12132C13.7031 4.92241 13.6241 4.73164 13.4835 4.59099L10.6121 1.71967C10.4715 1.57902 10.2807 1.5 10.0818 1.5H2.45312ZM0.203125 2.25C0.203125 1.00736 1.21048 0 2.45312 0H10.0818C10.6785 0 11.2508 0.237053 11.6728 0.65901L14.5441 3.53033C14.9661 3.95229 15.2031 4.52458 15.2031 5.12132V15.75C15.2031 16.9926 14.1958 18 12.9531 18H2.45312C1.21048 18 0.203125 16.9926 0.203125 15.75V2.25Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03516 3.91667V1.25H10.5352V3.91667C10.5352 4.33088 10.8709 4.66667 11.2852 4.66667H13.9518V6.16667H11.2852C10.0425 6.16667 9.03516 5.15931 9.03516 3.91667Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78516 9.16675C2.78516 8.75253 3.12094 8.41675 3.53516 8.41675L11.0352 8.41675C11.4494 8.41675 11.7852 8.75253 11.7852 9.16675C11.7852 9.58096 11.4494 9.91675 11.0352 9.91675L3.53516 9.91675C3.12094 9.91675 2.78516 9.58096 2.78516 9.16675Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78516 5C2.78516 4.58579 3.12094 4.25 3.53516 4.25L6.86849 4.25C7.2827 4.25 7.61849 4.58579 7.61849 5C7.61849 5.41421 7.2827 5.75 6.86849 5.75L3.53516 5.75C3.12094 5.75 2.78516 5.41421 2.78516 5Z",
    fill: "#434343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78516 13.3333C2.78516 12.919 3.12094 12.5833 3.53516 12.5833L11.0352 12.5833C11.4494 12.5833 11.7852 12.919 11.7852 13.3333C11.7852 13.7475 11.4494 14.0833 11.0352 14.0833L3.53516 14.0833C3.12094 14.0833 2.78516 13.7475 2.78516 13.3333Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c21758893f0636ca109a93e6525fe18a.svg";
export { ForwardRef as ReactComponent };